<template>
	<expose class="game-asset-expose" :active="game != null" v-on:expose-close="$root.$data.gameAsset = null">
<!-- 		<game-demo class="game-asset-expose__game" ref="gameWindow" :game="game" v-bind:style="{
			'width' : gameWidth + 'px'
		}"></game-demo>
 -->
 		<div class="game-asset-expose__container">
			<directory-listing v-if="game && game.downloadableAssets && game.downloadableAssets.hasChildren" ref="directoryListing" class="game-asset-expose__directory-listing" :directory="game.downloadableAssets" :root-name="game.gameName" />
		</div>
 	</expose>
</template>

<script>
import { filter } from 'lodash';

import Expose from '../molecules/Expose'
import DirectoryListing from '../organisms/DirectoryListing'

export default {
	name: 'GameAssetExpose',
	components: {
		Expose,
		DirectoryListing
	},
	data () {
		return {
			// directory: null,
			// padding: 16
		}
	},
	props: {
		game: Object
	},
	computed: {
		// gameWidth: function()
		// {
		// 	var self = this;
		// 	var gameWindow = self.$refs.gameWindow;
		// 	var winWidth = self.$root.$data.windowWidth;
		// 	var winHeight = self.$root.$data.windowHeight;
		// 	var winAspectRatio = winHeight / winWidth;
		// 	var chosenAR = Math.max(self.aspectRatio, winAspectRatio);

		// 	return (winHeight - 80) * (1 / chosenAR);
		// }
	},
  watch: {
		// game: function (newValue, oldValue)
		// {
		// 	var self = this;

		// 	if(newValue === null) { self.directory = null; }
		// 	else { self.refreshDirectory(); }
		// },
	},
	created: function()
	{
	},
	mounted: function()
	{
	},
	methods: {
		refreshDirectory()
		{
			var self = this;

			// self.$api.getGameAssetDirectory(self.game.id).then((success) => {

			// 	var assets = [];

			// 	if(success.hasOwnProperty('data') && success.data.length == 1 && success.data[0].hasChildren)
			// 	{
			// 		var privateFolder = filter(success.data[0].children, {name: '_private'});
			// 		if(privateFolder.length > 0)
			// 		{
			// 			privateFolder = privateFolder[0];
			// 			assets = privateFolder;
			// 		}
			// 	}

			// 	self.directory = assets;

			// }).catch((error) => {
			// 	console.log(error);
			// });
		}
	}
}
</script>

<style lang="scss">
	@import "src/scss/toolkit";

	$c: ".game-asset-expose";
	#{$c}
	{
		.expose__container
		{
			min-height: 100vh;
		}

		&__container
		{
			width: 992px;
			max-width: 100%;
			padding: rem(32);
			background-color: palette(white);
			color: palette(font);
			box-shadow: 0 1px 4px rgba(0,0,0,0.13);
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/organisms/GameAssetExpose.vue